var _path, _path2, _ellipse, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 83.0391V99.1665C52.5 115.275 65.5584 128.333 81.6667 128.333H86.8137C97.8197 128.333 107.097 120.931 109.938 110.833",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.668 17.5H31.1332C29.3082 17.5 28.3957 17.5 27.6265 17.568C19.1791 18.315 12.483 25.0112 11.736 33.4585C11.668 34.2278 11.668 35.1402 11.668 36.9652V42.2059C11.668 64.7575 29.9497 83.0392 52.5013 83.0392C74.1325 83.0392 91.668 65.5037 91.668 43.8725V36.9652C91.668 35.1402 91.668 34.2278 91.6 33.4585C90.853 25.0112 84.1568 18.315 75.7095 17.568C74.9402 17.5 74.0277 17.5 72.2027 17.5H71.668",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.832,
    cy: 93.3335,
    rx: 17.5,
    ry: 17.5,
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 11.6665V23.3332",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.6665V23.3332",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.5f8eb62dccec3e3447d9a876fa6999fe.svg";
export { ForwardRef as ReactComponent };